<template>
	<div class="parts">
		<v-header title="新闻资讯" :headerLeftStatus="true" />
		<div class="partsMain">
			<div class="news_main">
				<div class="news_main_title">
					<Text strong>{{newsInfo.infoTitle}}</Text>
				</div>
				<div class="news_main_author">
					<Text>{{newsInfo.authorName}}</Text>&nbsp;&nbsp;<Text>{{converterEx.toDateString(newsInfo.publishTime)}}</Text>
				</div>
				<div class="news_main_body" v-html="newsInfo.infoContent"></div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	import header from "@/components/header/index";
	import footer from "@/components/footer/index";
	import {
		sysPost
	} from '@/utils/api'
	export default {
		name: 'news',
		data() {
			return {
				newsInfo: {}, //新闻详细
			};
		},
		mounted() {
			var newsId = this.$route.query.Id;
			if (newsId) this.getNewsDetail(newsId);
		},
		methods: {
			getNewsDetail(newsId) {
				var that = this;
				sysPost(that, {
					"url": 'Wx/GetNewsDetail',
					"data": {
						"OrganizeInfo": newsId
					}
				}, function(result) {
					that.newsInfo = result
				});
			},
		},
		components: {
			"v-header": header,
			"v-footer": footer
		}
	}
</script>

<style lang="less" scoped>
	.parts {
		position: absolute;
		background: #ffffff;
		width: 100%;
		height: 100%;
		top: 0;
		bottom: 0;
		z-index: 999;
	}

	.partsHeader {
		width: 100%;
		z-index: 1;
		height: 1.3rem;
		line-height: 1.3rem;
		font-size: 12px;
		background: white;
		position: fixed;
		-webkit-box-shadow: 0 0 10px #cecece;
		box-shadow: 0 0 10px #cecece;
		text-align: center;
		font-size: 0.41rem;
	}

	.partsHeader i {
		display: block;
		float: left;
		height: 50px;
		padding-left: 0.3rem;
		font-size: 0.71rem;
		color: black;
	}

	.partsMain {
		margin-top: 1.02rem;
		height: 100%;
	}

	.news_main {
		height: 100%;
		margin-top: 70px;
	}

	.news_main_title {
		text-align: center;
		margin: 10px;
	}

	.news_main_org {
		text-align: center;
		font-size: 12px;
		margin: 10px;
	}

	.news_main_author {
		text-align: center;
		font-size: 12px;
		margin: 10px;
	}

	.news_main_body {
		margin: 10px;
		font-size: 13px;
		font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	}
</style>
